import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { Loader2 } from "lucide-react";
import { useDeleteImporter } from "@/api/importer.api";
import { ImporterDto } from "@/types/api/api-types";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  importer: ImporterDto;
};

export const ImporterDeleteModal = ({ open, onClose, importer }: Props) => {
  const { t } = useTranslation(["boCatalog", "common"]);
  const { mutateAsync: deleteImporter, isPending } = useDeleteImporter();

  const handleDelete = async () => {
    await deleteImporter(importer.id);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("importerDeleteModal.title")}
      description={t("importerDeleteModal.description", { importerName: importer.name })}
      size="sm"
      contentClassName="max-w-[400px]"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? <Loader2 className="animate-spin" /> : t("importerDeleteModal.submit")}
          </Button>
        </>
      }
    />
  );
};
